import gsap, { Power2 } from 'gsap';
import { SplitText } from 'gsap/SplitText';

gsap.registerPlugin(SplitText);

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { Ease } from '../_app/cuchillo/utils/Ease';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';

export class ScrollItem__CarList extends VScroll_Item {
    cards;

    //==================================================================================================================
    //          CONSTRUCTOR
    //==================================================================================================================
    constructor(__link, __index, __scroller) {
        super(__link, __index, __scroller);

        this.setAnimations();

        this.onShow = () => {
            this.showFunction();
        };
        this.onHide = () => {
            this.hideFunction();
        };
        this.onMove = () => {
            this.moveFunction();
        };
    }

    setAnimations() {
        const cards = GetBy.selector('.car-card', this.item);
        if (cards.length > 0) {
            this.cards = cards;
            gsap.set(cards, { opacity: 0 });
        }
    }

    showFunction() {
        let delay = 0;

        if (this.cards.length > 0) {
            for (let i = 0; i < this.cards.length; i++) {
                const card = this.cards[i];
                gsap.to(card, {
                    opacity: 1,
                    delay: delay + i * .1,
                    duration: 1,
                    ease: Ease.EASE_CUCHILLO_IN_OUT
                });
            }
        }
    }

    hideFunction() { }

    moveFunction() { }
}

Scroll._registerClass('CarList', ScrollItem__CarList);
